import { render, staticRenderFns } from "./TotalPointsEarnedCard.vue?vue&type=template&id=7b9a25b9&scoped=true"
import script from "./TotalPointsEarnedCard.vue?vue&type=script&lang=js"
export * from "./TotalPointsEarnedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9a25b9",
  null
  
)

export default component.exports